import { render, staticRenderFns } from "./NavitionTransactionChart.vue?vue&type=template&id=8641c9d8&scoped=true&"
import script from "./NavitionTransactionChart.vue?vue&type=script&lang=js&"
export * from "./NavitionTransactionChart.vue?vue&type=script&lang=js&"
import style0 from "./NavitionTransactionChart.vue?vue&type=style&index=0&id=8641c9d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8641c9d8",
  null
  
)

export default component.exports